import { z } from "zod";
import { studyFieldRegex } from "../../constants/regex";
import { zCodeListSchema, zString } from "./commonSchemaObjects";

const armTypeObject = z.object({
  arm_description: z.string().nullable().optional(),
  arm_title: z.string(),
  arm_type_code: z.string(),
  arm_type_value_code: z.string(),
  arm_type: z.string(), 
});
const requiredDateValidation = z.string({ invalid_type_error: "Required" }).refine((value)=>value!='Invalid Date',{message:"Invalid Date"})
export const studySchema = z.object({
  study_id: z
    .string()
    .min(1, "Required")
    .regex(
      studyFieldRegex,
      "Field must be alphanumeric and can include #, _, - with no spaces"
    ),
  ind: z
    .union([
      z
        .number({ invalid_type_error: "Required" })
        .min(100000, "Value must be 6 digits ")
        .max(999999, "Value must be at most 999999"),
      z.null(),
    ])
    .nullable()
    .refine((value) => value === null || value >= 0, {
      message: "Value must be non-negative",
    }),
  title: zString.zRequired,
  study_type: zCodeListSchema,
  treatments: z
    .array(z.string())
    .optional(),
  conditions: z.array(z.string()).min(1, "Minimum one disease(s) is required"),
  start_date: requiredDateValidation,
  primary_completion_date: requiredDateValidation,
  study_completion_date: requiredDateValidation,
  enrollment: z
    .union([
      z
        .number({ invalid_type_error: "Required" })
        .min(1, "Value must be at least 1")
        .max(99999, "Value must be at most 99999"),
      z.null(),
    ])
    .nullable()
    .refine((value) => value === null || value >= 0, {
      message: "Value must be non-negative",
    }),
  brief_summary: zString.zRequired,
  study_status: zCodeListSchema,
  study_phase: zCodeListSchema,
  study_arms: z.array(armTypeObject).optional(),
});
